import { useRef } from "react";
import useStore, { event } from "./useStore";
import { getBalanceInfo } from "../request/server";
import { hasToken } from "../utils";

const useBalance = <T>(): [
  {
    data?: T;
    error?: any;
    loading: boolean;
  },
  () => void
] => {
  const data = useStore<T>("balance", getBalanceInfo, hasToken());
  const update = useRef<() => void>(() => {
    event.dispatchEvent(new CustomEvent("balance:update"))
  });
  return [data, update.current];
};

export default useBalance;
